import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { trackLanguageSwitch } from '../utils/analytics';

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng: string) => {
    const currentLang = i18n.language;
    i18n.changeLanguage(lng);
    
    // Track language switch
    trackLanguageSwitch(currentLang, lng);
  };

  return (
    <div className="relative group">
      <button
        className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors backdrop-blur-sm border border-white/20"
        aria-label={t('language.switch')}
      >
        <Globe className="w-5 h-5" />
        <span className="text-sm font-medium">
          {i18n.language === 'et' ? 'ET' : 'EN'}
        </span>
      </button>
      
      <div className="absolute top-full right-0 mt-2 w-32 bg-white/95 backdrop-blur-sm rounded-lg shadow-lg border border-white/20 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        <button
          onClick={() => changeLanguage('en')}
          className={`w-full px-4 py-2 text-left text-sm hover:bg-white/20 transition-colors first:rounded-t-lg ${
            i18n.language === 'en' ? 'bg-blue-100 text-blue-700' : 'text-gray-700'
          }`}
        >
          {t('language.english')}
        </button>
        <button
          onClick={() => changeLanguage('et')}
          className={`w-full px-4 py-2 text-left text-sm hover:bg-white/20 transition-colors last:rounded-b-lg ${
            i18n.language === 'et' ? 'bg-blue-100 text-blue-700' : 'text-gray-700'
          }`}
        >
          {t('language.estonian')}
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
